import {
    Button,
    Card,
    CardContent,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { If, Else } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { useRefresh } from "lib/@hooks/useRefresh"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { GrantRow } from "./grant-row"
import { GrantEditor } from "./grant-editor"
import { saveGrant } from "../controller/save-grant"

export function OverridesSection() {
    const { breakdown, scope, subjectId, clientId } = useBoundContext()
    const editGrant = useDialog(<GrantEditor />, { maxWidth: "md", fullWidth: true })
    const refresh = useRefresh()
    const grants = breakdown.grants ?? []

    return (
        <Card data-cy="access-overrides-section">
            <CardContent>
                <Stack spacing={1.5}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle1">Overrides</Typography>
                        <Button
                            size="small"
                            variant="outlined"
                            data-cy="access-add-override"
                            startIcon={<Iconify icon="mdi:plus" />}
                            onClick={addOverride}
                        >
                            Add override
                        </Button>
                    </Stack>
                    <If value={grants.length > 0}>
                        <TableContainer>
                            <Table size="small" data-cy="access-overrides-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell width={40} />
                                        <TableCell>Name</TableCell>
                                        <TableCell>Starts</TableCell>
                                        <TableCell>Ends</TableCell>
                                        <TableCell>Active</TableCell>
                                        <TableCell>Demands</TableCell>
                                        <TableCell>Justification</TableCell>
                                        <TableCell align="right" />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <Repeat list={grants} item={<GrantRow onSaved={refresh} />} keyFn={keyOf} />
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Else>
                            <Typography variant="body2" color="text.secondary">
                                No overrides. Add one to grant a capability this subject is not entitled to by purchase.
                            </Typography>
                        </Else>
                    </If>
                </Stack>
            </CardContent>
        </Card>
    )

    function keyOf(grant) {
        return grant.id
    }

    async function addOverride() {
        const grant = await editGrant({ grant: newGrant() })
        if (!grant) return
        try {
            await saveGrant(grant)
            successSnackbar("Override saved")
            refresh()
        } catch (e) {
            errorSnackbar(e.message ?? "Failed to save the override")
        }
    }

    function newGrant() {
        return {
            scope,
            subjectId,
            clientId,
            name: "",
            demands: [],
            bundleIds: [],
            enabled: true,
            notes: "",
            bypass: {},
        }
    }
}
